export const compressCaptureImage = async (file: File): Promise<Blob> => {
  const bitmap = await createImageBitmap(file);
  const maximumEdge = 1920;
  const scale = Math.min(1, maximumEdge / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Image processing is unavailable");
  context.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();
  return new Promise((resolve, reject) =>
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("Image compression failed"))),
      "image/jpeg",
      0.85
    )
  );
};

export const cropCaptureImage = async (
  imageUrl: string,
  options: { zoom: number; horizontal: number; vertical: number }
): Promise<Blob> => {
  const image = new Image();
  image.crossOrigin = "anonymous";
  image.src = imageUrl;
  await new Promise<void>((resolve, reject) => {
    image.onload = () => resolve();
    image.onerror = () => reject(new Error("Could not load image for cropping"));
  });

  const aspect = 4 / 3;
  let sourceWidth = image.naturalWidth / options.zoom;
  let sourceHeight = sourceWidth / aspect;
  if (sourceHeight > image.naturalHeight) {
    sourceHeight = image.naturalHeight / options.zoom;
    sourceWidth = sourceHeight * aspect;
  }
  const sourceX =
    (Math.max(0, image.naturalWidth - sourceWidth) * options.horizontal) / 100;
  const sourceY =
    (Math.max(0, image.naturalHeight - sourceHeight) * options.vertical) / 100;
  const outputWidth = Math.min(1600, Math.round(sourceWidth));
  const outputHeight = Math.round(outputWidth / aspect);
  const canvas = document.createElement("canvas");
  canvas.width = outputWidth;
  canvas.height = outputHeight;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Image crop is unavailable");
  context.drawImage(
    image,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    0,
    0,
    outputWidth,
    outputHeight
  );
  return new Promise((resolve, reject) =>
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("Image crop failed"))),
      "image/jpeg",
      0.9
    )
  );
};
